import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';
import { FormFieldState } from '../../hooks';

interface BottomBarProps {
  tong_thue?: number;
  tong_tien?: number;
  tong_chiet_khau?: number;
  tong_thanh_toan?: number;
  state: FormFieldState;
}

export function BottomBar({
  tong_thue = 0,
  tong_tien = 0,
  tong_chiet_khau = 0,
  tong_thanh_toan = 0,
  state
}: BottomBarProps) {
  const ck_yn = state.ck_yn;

  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[240px]',
      fields: [
        { name: 't_tien_nt', label: 'Tổng tiền', value: tong_tien, inputClassName: 'text-right' },
        { name: 't_thue_nt', label: 'Tổng thuế', value: tong_thue, inputClassName: 'text-right' }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [
        {
          name: 't_ck_nt',
          label: 'Tổng chiết khấu',
          value: tong_chiet_khau,
          inputClassName: 'text-right',
          hidden: !ck_yn
        }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [{ name: 't_tt_nt', label: 'Tổng thanh toán', value: tong_thanh_toan, inputClassName: 'text-right' }]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
}

export default BottomBar;
